import React, { useEffect, useState } from 'react';

import { sendMessageToOtherTabs } from "../../services/broadcastManager";

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import QRCode from 'qrcode.react';
import Cookies from 'js-cookie';
import { listenMessage, showSuccessToast, fullError } from '../../services/util';
import { fetchUserSessions, getUserId } from '../../services/api';

function QrCode(props) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [hasListened, setHasListened] = useState(false);

  /** Per rimuovere avvisi */
  if (hasListened);

  useEffect(() => {
    document.getElementById('navbarNav').classList.remove('show');
    props.setPageTo('qrCode');
    setHasListened(function (prevHasListened) {
      if (!prevHasListened) {
        listenMessage(async (rid) => {
          try {
            /** Prendo il rid passato per messaggio dal ristoratore, così da poter effettuare le chiamate */
            Cookies.set('rid', rid, { expires: 7 });
            const result = await fetchUserSessions(getUserId());
            if (result.result === 'OK') {
              Cookies.set('sessionId', result.data[0]._id, { expires: 7 });
            }
            props.setIsAssigned(true);
            props.refreshApp();
            props.setIsMenuModalOpen(true);
            sendMessageToOtherTabs("lazy_reload");
            showSuccessToast(t('tableAssignedSuccessfully'));
          } catch (error) {
            fullError(t('anErrorOccurred'), error);
          }
        }, 'qrcode_scan_' + getUserId(), 'isAssigned');
        return true;
      }
    });

  }, []);

  const handleRefresh = () => {
    props.setShowLoading(true);
    navigate("/");
    window.location.reload();
  };
  return (
    <div className="container px-5 py-4 text-center qrCodeBox bg-white">
      <h3 className="pb-4">Chiedi al ristorante di farti assegnare il tavolo tramite questo QR Code:</h3>
      <div className="d-flex justify-content-center align-items-center bg-white">
        <QRCode className="d-none d-lg-block" value={getUserId()} size="300" includeMargin={true} />
        <QRCode className="d-lg-none" value={getUserId()} size="100" includeMargin={true} />
      </div>
      <button onClick={() => handleRefresh()} className="w-100 btn btn-lg btn-primary mt-5" type="button">{t('update')}</button>

    </div>
  );
}
export default QrCode;